'use client';

import { ComponentType } from 'react';
import { PageSectionProps } from 'libs/contentful/props';
import { mappedModules, ModuleTypeName } from 'utils/modules';
import { ClientNinetailedExperience, NinetailedContentfulModule } from './ClientNinetailedExperience';
import { ExperienceConfiguration } from '@ninetailed/experience.js-react';
import { ModuleProps } from 'utils/modules';

/**
 * ClientWrapper is a wrapper component that renders a client Ninetailed experience for a given module
 * @param id - The id of the baseline entry
 * @param moduleType - The type of the module
 * @param passthroughProps - The passthrough props to render
 * @param experiences - The experiences to render
 * @param hasExperiments - Whether the page has experiments
 * @returns The rendered component
 */
interface ClientWrapperProps {
  id: string;
  moduleType: ModuleTypeName;
  passthroughProps: ModuleProps[ModuleTypeName];
  experiences: ExperienceConfiguration<NinetailedContentfulModule>[];
  hasExperiments?: boolean;
}

const ClientWrapper = ({
  id,
  moduleType,
  passthroughProps,
  experiences,
  hasExperiments = false,
}: ClientWrapperProps) => {
  const Module = mappedModules[moduleType] as ComponentType<PageSectionProps & ModuleProps[ModuleTypeName]>;

  return (
    <ClientNinetailedExperience
      id={id}
      module={Module}
      passthroughProps={
        { ...passthroughProps, __typename: moduleType, sys: { id } } as PageSectionProps & ModuleProps[ModuleTypeName]
      }
      experiences={experiences}
      hasExperiments={hasExperiments}
    />
  );
};

export default ClientWrapper;
